import { CommandsAndQueryProvider } from '@insify/funnel-components';
import { QueryClient } from 'react-query';

import { commandQueryReducer } from '../api/commandQueryReducer';

import type { Commands } from '../models/commands';
import type { QueryKeys } from '../models/queries';

const BASE_URL = window.insify_runtime_config.API_ENDPOINT;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: Infinity },
    mutations: { retry: 1 },
  },
});

/** Extend Commands provider from component library to handle sending commands + invalidating the connected queries  */
export const PncCommandsAndQueryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <CommandsAndQueryProvider<Commands, QueryKeys>
      queryClient={queryClient}
      commandQueryReducer={commandQueryReducer}
      createCommandEndpoint={(prospectId: string) => `${BASE_URL}frenchCompanyPolicyHolder_${prospectId}/command`}
    >
      {children}
    </CommandsAndQueryProvider>
  );
};
